<div class="screen">
  <app-navbar></app-navbar>
  <div class="dashboard-container">
    <div class="header-section">
      <div class="header-left">
        <h1 class="main-heading">Dashboard Summary</h1>
      </div>

      <div class="header-right">
        <button class="view-all-btn">View All Time Summary</button>
        <div class="date-picker-badge">
          <button class="nav-btn" (click)="prevDay()">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="3"
                 stroke-linecap="round" stroke-linejoin="round">
              <path d="M15 18l-6-6 6-6"/>
            </svg>
          </button>

          <div class="date-display" (click)="picker.open()" style="cursor: pointer;">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2.2"
                 stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
              <line x1="16" y1="2" x2="16" y2="6"/>
              <line x1="8" y1="2" x2="8" y2="6"/>
              <line x1="3" y1="10" x2="21" y2="10"/>
              <path d="M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01M16 18h.01"/>
            </svg>
            <span>{{ displayDate }}</span>
            <input matInput [matDatepicker]="picker" 
                   [value]="selectedDate"
                   (dateChange)="onMatDateChange($event)"
                   [max]="maxDate"
                   style="position: absolute; opacity: 0; width: 0; height: 0; pointer-events: none;">
            <mat-datepicker #picker panelClass="premium-calendar"></mat-datepicker>
          </div>

          <button class="nav-btn" (click)="nextDay()" [disabled]="selectedDate >= today">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="3"
                 stroke-linecap="round" stroke-linejoin="round">
              <path d="M9 18l6-6-6-6"/>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div class="content">
      <div
        *ngIf="loading"
        class="center-message-wrapper"
        role="status"
        aria-live="polite"
        aria-busy="true"
      >
        <div class="center-message">
          <div class="spinner" aria-hidden="true"></div>
        </div>
      </div>

      <div
        *ngIf="!loading && error"
        class="center-message-wrapper"
        role="alert"
      >
        <div class="center-message">
          <div>
            <strong>{{ error }}</strong>
            <div style="margin-top: 8px">
              <button (click)="loadForSelectedDate()">Retry</button>
            </div>
          </div>
        </div>
      </div>

      <ng-container *ngIf="!loading && !error">
        <section class="stats-row">
          <article class="stat-card">
            <div class="stat-title">Total Bids</div>
            <div class="stat-value">{{ display(stats?.total_bids) }}</div>
            <div class="stat-subtext" [class.trend-up]="stats?.percentage_change > 0" [class.trend-down]="stats?.percentage_change < 0">
              <span *ngIf="stats?.percentage_change > 0" class="arrow up"
                >▲</span
              >

              <span *ngIf="stats?.percentage_change < 0" class="arrow down"
                >▼</span
              >

              <span *ngIf="stats?.percentage_change !== 0">
                {{ display(abs(stats?.percentage_change)) }}% from yesterday
              </span>

              <span *ngIf="stats?.percentage_change === 0">
                No change from yesterday
              </span>
            </div>
          </article>

          <article class="stat-card">
            <div class="stat-title">Strike Price</div>
            <div class="stat-value">₹{{ display(stats?.strike_price) }}</div>
            <div class="stat-subtext">Average today</div>
          </article>

          <article class="stat-card">
            <div class="stat-title">Total Value</div>
            <div class="stat-value">₹{{ display(stats?.total_value) }}</div>
            <div class="stat-subtext">Total  traded volume</div>
          </article>

          <article class="stat-card">
            <div class="stat-title">Energy Traded</div>
            <div class="stat-value">{{ display(stats?.energy_traded) }}</div>
            <div class="stat-unit">kWh</div>
          </article>

          <article class="stat-card">
            <div class="stat-title">Untraded Energy</div>
            <div class="stat-value">{{ display(stats?.untraded_energy) }}</div>
            <div class="stat-unit">kWh</div>
          </article>
        </section>

        <div class="bottom-stats-grid">
          <section class="large-card">
            <div class="card-header">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                   stroke="#059669" stroke-width="2.5"
                   stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="20" x2="18" y2="10"/>
                <line x1="12" y1="20" x2="12" y2="4"/>
                <line x1="6" y1="20" x2="6" y2="14"/>
              </svg>
              <h2 class="section-title">Participation Statistics</h2>
            </div>
            <div class="dashed-separator"></div>

            <ul class="kv-list">
              <li>
                <div class="kv-left">
                  <img src="assets/buyer-cart.svg" alt="buyer cart" />
                  <span>Buyers</span>
                </div>
                <span class="kv-right">{{ display(stats?.buyers) }}</span>
              </li>
              <li>
                <div class="kv-left">
                  <img src="assets/seller-house.svg" alt="seller house" />
                  <span>Sellers</span>
                </div>
                <span class="kv-right">{{ display(stats?.sellers) }}</span>
              </li>
              <li>
                <div class="kv-left">
                  <img src="assets/user-logo.svg" alt="user logo" />
                  <span>Active Participants</span>
                </div>
                <span class="kv-right">{{
                  display(stats?.active_participants)
                }}</span>
              </li>
              <li>
                <div class="kv-left">
                  <img src="assets/bids-accepted.svg" alt="bids accepted" />
                  <span>Bids Accepted</span>
                </div>
                <span class="kv-right">{{
                  display(stats?.bids_accepted)
                }}</span>
              </li>
              <li>
                <div class="kv-left">
                  <img src="assets/bigs-rejected.svg" alt="bids rejected" />
                  <span>Bids Rejected</span>
                </div>
                <span class="kv-right">{{
                  display(stats?.bids_rejected)
                }}</span>
              </li>
              <li>
                <div class="kv-left">
                  <img src="assets/total-energy.svg" alt="total energy" />
                  <span>Total Energy Bids </span>
                </div>
                <span class="kv-right strong"
                  >{{ display(stats?.total_energy_traded) }} kWh</span
                >
              </li>
            </ul>
          </section>

          <section class="large-card">
            <div class="card-header">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                   stroke="#059669" stroke-width="2.5"
                   stroke-linecap="round" stroke-linejoin="round">
                <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
                <line x1="8" y1="21" x2="16" y2="21"/>
                <line x1="12" y1="17" x2="12" y2="21"/>
                <path d="M7 10l3 3 7-7"/>
              </svg>
              <h2 class="section-title">Chart</h2>
            </div>
            <div class="dashed-separator"></div>

            <div class="chart-content-area">
              <div class="chart-legend">
                <div class="legend-item">
                  <span class="legend-circle buy"></span>
                  <span>Buy</span>
                </div>
                <div class="legend-item">
                  <span class="legend-circle sell"></span>
                  <span>Sell</span>
                </div>
                <div class="legend-item">
                  <span class="legend-circle total"></span>
                  <span>Total</span>
                </div>
              </div>

              <div #chartWrap class="chart-wrap">
              <svg
                viewBox="0 0 600 280"
                class="chart-svg"
                role="img"
                aria-label="Trade volume bar chart"
              >
                <rect
                  x="0"
                  y="0"
                  width="600"
                  height="320"
                  fill="transparent"
                  rx="12"
                />

                <g *ngFor="let t of chartTicks">
                  <line
                    [attr.x1]="SVG.left"
                    [attr.x2]="SVG.right"
                    [attr.y1]="getYForValue(t)"
                    [attr.y2]="getYForValue(t)"
                    [attr.stroke]="t === 0 ? '#8aa6ac' : '#9bb3b8'"
                    [attr.stroke-width]="t === 0 ? 2 : 1"
                    [attr.stroke-dasharray]="t === 0 ? '' : '4 6'"
                  ></line>

                  <text
                    [attr.x]="SVG.left - 6"
                    [attr.y]="getYForValue(t)"
                    dominant-baseline="middle"
                    text-anchor="end"
                    font-family="sans-serif"
                    font-size="14"
                    font-weight="800"
                    fill="#000000"
                  >
                    {{ t }}
                  </text>
                </g>
                <g
                  [attr.transform]="
                    'translate(15, ' +
                    (SVG.top + SVG.bottom) / 2 +
                    ') rotate(-90)'
                  "
                >
                  <text
                    text-anchor="middle"
                    dominant-baseline="central"
                    font-size="14"
                    font-weight="900"
                    fill="#111827"
                    style="text-transform: uppercase; letter-spacing: 0.05em;"
                  >
                    Trade Volume
                  </text>
                </g>

                <!-- X Axis Title -->
                <text
                  [attr.x]="(SVG.left + SVG.right) / 2"
                  [attr.y]="SVG.bottom + 45"
                  text-anchor="middle"
                  font-size="14"
                  font-weight="900"
                  fill="#111827"
                  style="text-transform: uppercase; letter-spacing: 0.05em;"
                >
                  Date
                </text>

                <line
                  [attr.x1]="SVG.left"
                  [attr.y1]="SVG.bottom"
                  [attr.x2]="SVG.right"
                  [attr.y2]="SVG.bottom"
                  stroke="#b7d2d7"
                  stroke-width="2"
                />
                <line
                  [attr.x1]="SVG.left"
                  [attr.y1]="SVG.top"
                  [attr.x2]="SVG.left"
                  [attr.y2]="SVG.bottom"
                  stroke="#b7d2d7"
                  stroke-width="2"
                />


                <g *ngIf="!chartLoading">
                  <g *ngFor="let g of chartGroups; let i = index">
                    <!-- buy -->
                    <rect
                      [attr.x]="getBarX(i, -1)"
                      [attr.y]="getBarYForVolume(g.buy_volume)"
                      [attr.width]="getBarWidth()"
                      [attr.height]="getBarHeightForVolume(g.buy_volume)"
                      rx="4"
                      fill="#69b36d"
                      (mousemove)="onBarHover($event, g.buy_volume)"
                      (mouseleave)="hideTooltip()"
                    >
                    </rect>

                    <!-- sell -->
                    <rect
                      [attr.x]="getBarX(i, 0)"
                      [attr.y]="getBarYForVolume(g.sell_volume)"
                      [attr.width]="getBarWidth()"
                      [attr.height]="getBarHeightForVolume(g.sell_volume)"
                      rx="4"
                      fill="#f3c23a"
                      (mousemove)="onBarHover($event, g.sell_volume)"
                      (mouseleave)="hideTooltip()"
                    >
                    </rect>

                    <!-- total -->
                    <rect
                      [attr.x]="getBarX(i, 1)"
                      [attr.y]="getBarYForVolume(g.total_volume)"
                      [attr.width]="getBarWidth()"
                      [attr.height]="getBarHeightForVolume(g.total_volume)"
                      rx="4"
                      fill="#1B6364"
                      (mousemove)="onBarHover($event, g.total_volume)"
                      (mouseleave)="hideTooltip()"
                    >
                    </rect>

                    <!-- x label -->
                    <text
                      [attr.x]="getGroupCenterX(i)"
                      [attr.y]="SVG.bottom + 20"
                      font-family="sans-serif"
                      font-size="13"
                      fill="#1f2937"
                      font-weight="800"
                      text-anchor="middle"
                    >
                      {{ formatXLabel(g.date) }}
                    </text>
                  </g>
                </g>

                <!-- chart-loading overlay -->
                <g *ngIf="chartLoading">
                  <rect
                    [attr.x]="SVG.left"
                    [attr.y]="SVG.top"
                    [attr.width]="SVG.right - SVG.left"
                    [attr.height]="SVG.bottom - SVG.top"
                    fill="rgba(255,255,255,0.7)"
                  ></rect>
                  <g transform="translate(300,160)">
                    <circle
                      cx="0"
                      cy="0"
                      r="14"
                      stroke="#000000"
                      stroke-width="3"
                      fill="none"
                      stroke-linecap="round"
                    >
                      <animateTransform
                        attributeName="transform"
                        type="rotate"
                        from="0"
                        to="360"
                        dur="0.8s"
                        repeatCount="indefinite"
                      />
                    </circle>
                  </g>
                </g>
              </svg>

              <div
                class="chart-tooltip"
                *ngIf="tooltipVisible"
                [style.left.px]="tooltipX"
                [style.top.px]="tooltipY"
                role="tooltip"
              >
                {{ tooltipText }}
              </div>
            </div>
          </div>
        </section>
      </div>
    </ng-container>
  </div>

    <div class="dashboard-footer">Powered By Hygge Energy</div>
  </div>
</div>
